// extracted by mini-css-extract-plugin
export default {"root":"KeyFeatures__root--z8TNh","list":"KeyFeatures__list--_tOf8"};